import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PriceContext } from '../Context/PriceContext';
import calendar_icon from '../Assets/calendar_icon.png';
import pen_paper_icon from '../Assets/pen_paper_icon.png';
import word_count_icon from '../Assets/word_count_icon.png';
import Drop from './Drop';
import './PriceCalculator.css';
import Mount from '../Mount';
import { Helmet } from 'react-helmet';

const PriceCalculator = () => {
  const { paymentData = {}, setPaymentData = () => {} } = useContext(PriceContext);
  const [wordcount, setWordcount] = useState(paymentData.wordcount || '');
  const [deliveryTurnaround, setDeliveryTurnaround] = useState(paymentData.deliveryTurnaround || '');
  const [documentType, setDocumentType] = useState(paymentData.documentType || '');
  const navigate = useNavigate();

  const handleWordcountChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setWordcount(value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')); 
  }

  const handleDeliveryTurnaroundChange = (value) => {
    setDeliveryTurnaround(value);
  };

  const handleDocumentTypeChange = (value) => {
    setDocumentType(value);
  };

  const handleNewProjectClick = (e) => {
    e.preventDefault();
    if (wordcount && deliveryTurnaround && documentType) {
      setPaymentData((prevData) => ({
        ...prevData,
        wordcount,
        deliveryTurnaround,
        documentType,
      }));
      navigate('/add-services');
    } else {
      alert("Please ensure all fields are correct before proceeding.");
    }
  };

  return (
    <div className='setter'>
      <Helmet>
        <title>Price Calculator|Contranorm Media & Production&nbsp;&trade;</title>
      </Helmet>
      <Mount>
        <div className="page">
          <h1>
            <div className="text">Start Your Project</div>
          </h1>
          <div className="underline"></div>
          <form onSubmit=   {handleNewProjectClick}>
            <div className="price-options">
              <div className="doubleColumn">
                <div className="wordCount">
                  <img src={word_count_icon} id="word_count_icon" alt="" />
                  <input type="text" placeholder='Word Count' value={wordcount} onChange={handleWordcountChange} />
                </div>
                <div className='dropOptions'>
                
                  <Drop
                    className='DeliveryTurnaround' options={["Same Day (4-6hrs)", "Next Day (24hrs)", "Priority (72 hours)", "Standard (5-7 days)"]}
                    onSelect={handleDeliveryTurnaroundChange}
                    icon={calendar_icon}
                  />
                  <Drop
                  className='DocumentType'
                  options={[
                    "Affidavit",
                    "Business Letter",
                    "Cease & Desist",
                    "(EEOC) Equal Employment Opportunity Commission",
                    "Formal Grievance",
                    "Formal Notice",
                    "Government Resume",
                    "Grant Proposal",
                    "Informal Resolution Attempt",
                    "Initial Filing (Administrative Proceeding)",
                    "Letter of Inquiry",
                    "Memorandum",
                    "(MSPB) Merit System Protection Board",
                    "Modern Resume",
                    "Motion",
                    "Notice of Non-Compliance",
                    "(OSC) Office of Special Counsel",
                    "(OWCP) Office of Worker's Compensation",
                    "Pleading",
                    "Professional Resume",
                    "Statement of Fact",
                    "Other - Service Type"
                  ].sort()} // Sorting the options array alphabetically
                  onSelect={handleDocumentTypeChange}
                  icon={pen_paper_icon}
                  />
                </div>
                
              </div>
              
            </div>
           
          
          </form>
          <div className='submit-options'>
           
            <div className="submit-container">
              <button type="button" className="submit gray" onClick={() => navigate('/login-signup')}>Login</button>
          
              <button type="submit" className="submit" onClick={handleNewProjectClick}>
                Get Quote
              </button>
            </div>
             <div className="log-link-text">
              <a href="https://compliance.contranormdigital.com/" target="_blank" rel="noopener noreferrer">
              <span>Terms & Conditions</span>
              </a>
            </div>
          

          </div>
           
    
          
          
          
        </div>
      </Mount>
    </div>
  );
};

export default PriceCalculator;
